export default __webpack_public_path__ + "static/media/093-undo-1.dec8ba93.png";